export enum ContractType {
  LONG_TERM = 'LONG_TERM',
  FIXED_TERM = 'FIXED_TERM',
  BY_JOB = 'BY_JOB',
  FOR_LEARNING = 'FOR_LEARNING',
  TEMPORARY = 'TEMPORARY',
};
